import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-forbidden',
  templateUrl: './forbidden.component.html',
  styleUrls: ['./forbidden.component.scss'],
  standalone: false,
})
export class ForbiddenComponent implements OnInit {
  private route = inject(ActivatedRoute);

  title: string;

  ngOnInit() {
    this.route.data.subscribe((d) => (this.title = d.title));
  }
}
